import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExport = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "import_export_24px",
		children: /* @__PURE__ */ _jsx("path", {
			id: "icon/communication/import_export_24px",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5 6.99L9 3L13 6.99H10V14H8V6.99H5ZM16 10V17.01H19L15 21L11 17.01H14V10H16Z",
			fill: "#fad504"
		})
	})]
});
const ForwardRef = forwardRef(SvgExport);
export default ForwardRef;
